import { Nav, NavLink, NavItem } from "reactstrap";
import { useState, Fragment } from "react";
import { SocailAppCallBackType } from "../../../Type/SocialAppType";
import { Href } from "../../../Constant";
import { SOCIAL_NAV_DATA } from "../../../Data/SocialApp";

const NavBarMain = ({ callback }: SocailAppCallBackType) => {
  const [activeTab, setActiveTab] = useState(1);

  const tabHandler = ( id : number) => {
    setActiveTab(id);
    callback(id);
  };

  return (
    <Nav tabs className="border-tab tabs-scoial">
      {SOCIAL_NAV_DATA.map((data, index) => (
        <Fragment key={index}>
          {data.userProfile ? (
            <NavItem>
              <div className="user-designation" />
              <div className="title">
                <a href={Href}>ElANA</a>
              </div>
              <div className="desc mt-2">general manager</div>
            </NavItem>
          ) : (
            <NavItem className="nav">
              <NavLink className={activeTab === data.id ? "active" : ""} onClick={() => tabHandler(data.id)}>
                {data.tittle}
              </NavLink>
            </NavItem>
          )}
        </Fragment>
      ))}
    </Nav>
  );
};

export default NavBarMain;
